// src/utils/formatters.js

import { Star } from 'lucide-react';

/**
 * Utilitário para copiar texto para a área de transferência.
 * @param {string} text - O texto a ser copiado.
 * @param {string} successMessage - Mensagem de sucesso opcional.
 */
export const copyToClipboard = (text, successMessage) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
            // cópia realizada — sem side-effect em produção
        }).catch(err => {
            console.error('Falha ao copiar:', err);
            // Usar um alert aqui é permitido para fallback de clipboard.
            alert('Falha ao copiar. Tente selecionar e copiar manualmente.'); 
        });
    } else {
        alert('Seu navegador não suporta a API de clipboard. Selecione e copie manualmente o emoji: ' + text);
    }
};

/**
 * Gera um placeholder de avatar circular com a inicial do nome.
 * @param {string} name - Nome do usuário.
 * @returns {JSX.Element} - Componente de div com inicial e cor de fundo.
 */
export const getAvatarPlaceholder = (name) => {
    const initial = name ? name.trim().charAt(0).toUpperCase() : '?';
    
    // Hash simples para atribuir uma cor consistente
    let hash = 0;
    if (name) {
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
    }
    const colorIndex = Math.abs(hash) % 5;
    const colors = ['bg-blue-600', 'bg-green-600', 'bg-pink-600', 'bg-yellow-600', 'bg-red-600'];

    return (
        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg text-white ${colors[colorIndex]} flex-shrink-0`}>
            {initial}
        </div>
    );
};

/**
 * Renderiza estrelas de influência.
 * @param {number} influence - Nível de influência (1-3).
 * @returns {JSX.Element} - Ícones de estrela.
 */
export const renderInfluenceStars = (influence) => {
    return (
        <div className='flex items-center gap-1 flex-shrink-0'>
            {[1, 2, 3].map(i => (
                <Star key={i} className={`w-4 h-4 ${i <= influence ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'}`} />
            ))}
        </div>
    );
};

/**
 * Formata um número como moeda BRL (ex: 1234.5 → "1.234,50").
 * @param {number} value
 * @returns {string}
 */
export const fmtBRL = (value) =>
    Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Retorna uma saudação baseada na hora do dia.
 * @returns {string}
 */
export const getTimeOfDayGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Bom dia";
    if (hour < 18) return "Boa tarde";
    return "Boa noite";
};
